module.exports = __webpack_public_path__ + "img/logo3.711d3fc3.png";